import { render, staticRenderFns } from "./ticketdetailed.vue?vue&type=template&id=018617c2"
import script from "./ticketdetailed.vue?vue&type=script&lang=js"
export * from "./ticketdetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports